import React from 'react';
import { Box } from '@mui/material';
import { List, ListItemButton, ListItemText, Collapse, ButtonGroup, Button } from '@mui/material';
import { IconButton, Tooltip, Popover } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import MoreIcon from '@mui/icons-material/MoreVertRounded';
import ClearIcon from '@mui/icons-material/DeleteForeverRounded';
import DuplicateIcon from '@mui/icons-material/FilterNoneRounded';
import { randomString } from '../../../../../../utilities/randomUtilities';
import ShapePreview from './ShapePreview';
import ParticlesShapeListItem from './inputs/ParticlesShapeListItem';
import ParticlesColorListItem from './inputs/ParticlesColorListItem';
import ParticlesOpacityListItem from './inputs/ParticlesOpacityListItem';
import ParticlesRotationListItem from './inputs/ParticlesRotationListItem';
import ParticlesSizeListItem from './inputs/ParticlesSizeListItem';
import ParticlesSpawnRateListItem from './inputs/ParticlesSpawnRateListItem';
import ParticlesFlickeringListItem from './inputs/ParticlesFlickeringListItem';

const styles = theme => ({
    item: {
        background: theme.palette.action.hover,
    },
    collapse: {
        cursor: "default",
        backgroundColor: theme.palette.background.paperDark
    }
});

class ParticleElementListItem extends React.Component {
    state = {
        menuId: randomString(),
        open: false,
        menuAnchorEl: null
    }

    render() {
        const { classes, remove, duplicate, index } = this.props;
        const { menuId, open, menuAnchorEl } = this.state;

        return (
            <>
                <ListItemButton
                    onClick={() => this.setState({ open: !open })}
                    aria-expanded={open}
                    sx={{ cursor: "pointer" }}
                    className={open ? classes.item : null}
                >
                    <ListItemText>
                        <ShapePreview index={index} />
                    </ListItemText>
                    <Box>
                        <IconButton
                            size='small'
                            aria-controls={menuId}
                            aria-haspopup='true'
                            onClick={(event) => {
                                event.stopPropagation();
                                this.setState({ menuAnchorEl: event.currentTarget });
                            }}
                        >
                            <MoreIcon />
                        </IconButton>
                    </Box>
                </ListItemButton>
                <Popover
                    anchorEl={menuAnchorEl}
                    id={menuId}
                    keepMounted
                    open={Boolean(menuAnchorEl)}
                    onClose={() => this.setState({ menuAnchorEl: null })}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    style={{ lineHeight: 0 }}
                >
                    <ButtonGroup
                        size='small'
                        aria-label='Particle element action button group'
                        variant='text'
                    >
                        <Tooltip
                            title={duplicate ? 'Duplicate' : ''}
                            placement='top'
                            arrow
                        >
                            <Button
                                onClick={this.handleDuplicate}
                                disabled={!Boolean(duplicate)}
                                aria-label='Duplicate'
                            >
                                <DuplicateIcon />
                            </Button>
                        </Tooltip>
                        <Tooltip
                            title={remove ? 'Remove' : ''}
                            placement='top'
                            arrow
                        >
                            <Button
                                onClick={this.handleRemove}
                                disabled={!Boolean(remove)}
                                aria-label='Remove'
                            >
                                <ClearIcon />
                            </Button>
                        </Tooltip>
                    </ButtonGroup>
                </Popover>
                <Collapse
                    in={open}
                    timeout='auto'
                    unmountOnExit
                    className={classes.collapse}
                >
                    <List
                        dense
                        disablePadding
                    >
                        <ParticlesShapeListItem index={index} />
                        <ParticlesSpawnRateListItem index={index} />
                        <ParticlesColorListItem index={index} />
                        <ParticlesSizeListItem index={index} />
                        <ParticlesOpacityListItem index={index} />
                        <ParticlesRotationListItem index={index} />
                        <ParticlesFlickeringListItem index={index} />
                    </List>
                </Collapse>
            </>
        );
    }

    handleDuplicate = () => {
        const { duplicate } = this.props;
        duplicate();
        this.setState({ menuAnchorEl: null });
    }

    handleRemove = () => {
        const { remove } = this.props;
        remove();
        this.setState({ menuAnchorEl: null });
    }
}

export default withStyles(ParticleElementListItem, styles);
